import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import { Snackbar, Slide } from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions';

import { setSnackbar } from '../redux/workBackendSlice';
import useWorkBackend from '../hooks/useWorkBackend';
import useCurrentUserId from '../hooks/useCurrentUserId';
import useUserCondition from '../hooks/useUserCondition';

import UserHome from './UserHome';
import UserSettings from './UserSettings';
import BookEditor from './BookEditor';
import ChangePlanScene from './ChangePlanScene';
import DeleteAccountScene from './DeleteAccountScene';
import ChangePaymentScene from './ChangePaymentScene';
import ChangeUserLanguageScene from './ChangeUserLanguageScene';
import SignUpScene from './SignUpScene';
import DoneSignupScene from './DoneSignupScene';
import ShopDialog from '../shop_components/ShopDialog';

const GlobalStyle = createGlobalStyle`
  body {
    font-family: Roboto, sans-serif;
  }
  img {
     pointer-events: none;
  }
`

const DownTransition = (props: TransitionProps) => {
  return <Slide {...props} direction="down" />;
}

const Digimagi: React.FC = () => {
  const dispatch = useDispatch();
  let holded = false;
  const { authUser, snackbar } = useWorkBackend();
  const userId = useCurrentUserId();
  const [userConditionId, userCondition] = useUserCondition(userId);
  const [redirected, setRedirected] = useState(false);
  const [appBarFrom, setAppBarFrom] = useState<'/' | '/book'>('/');

  const handleSnackbarClose = () => {
    dispatch(setSnackbar({ open: false, message: '' }));
  }
  const changeHolded = (value: boolean) => {
    holded = value;
  }
  const handleKeyDown = (ev: KeyboardEvent) => {
    if (ev.key === 'Meta') changeHolded(true);
    // if (holded && ev.key === 's') {
    //   ev.preventDefault();
    //   dispatch(saveAllDb());
    // }
  }
  const handleKeyUp = () => {
    changeHolded(false);
  }

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('keyup', handleKeyUp);
  }, [])

  return (
    <div onContextMenu={(ev) => ev.preventDefault()}>
      { authUser === null ? <></> :
        <div id="digimagi-div">
          <Router>
            <Switch>
              <Route exact path="/">
                <UserHome redirected={redirected} setRedirected={(value) => setRedirected(value)} setAppBarFrom={setAppBarFrom} userConditionId={userConditionId} userCondition={userCondition} />
              </Route>
              <Route exact path="/userSettings">
                <UserSettings redirected={redirected} setRedirected={setRedirected} appBarFrom={appBarFrom} />
              </Route>
              <Route exact path="/changePlan">
                <ChangePlanScene redirected={redirected} setRedirected={setRedirected} />
              </Route>
              <Route exact path="/deleteAccount">
                <DeleteAccountScene redirected={redirected} doneRedirect={() => setRedirected(true)} />
              </Route>
              <Route exact path="/changePayment">
                <ChangePaymentScene redirected={redirected} setRedirected={setRedirected} />
              </Route>
              <Route exact path="/changeUserLanguage">
                <ChangeUserLanguageScene redirected={redirected} setRedirected={setRedirected} />
              </Route>
              <Route exact path="/signup">
                <SignUpScene redirected={redirected} setRedirected={setRedirected} />
              </Route>
              <Route exact path="/book">
                <BookEditor redirected={redirected} setRedirected={setRedirected} setAppBarFrom={setAppBarFrom} />
              </Route>
              <Route exact path="/doneSignup">
                <DoneSignupScene redirected={redirected} setRedirected={setRedirected} />
              </Route>
            </Switch>
            <GlobalStyle />
            <Link id='link-to-book' to='/book' />
          </Router>
          <Snackbar
            open={snackbar.open}
            onClose={handleSnackbarClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            TransitionComponent={DownTransition}
            message={snackbar.message}
            autoHideDuration={2000}
          />
          <ShopDialog />
        </div>
      }
    </div>
  );
}

export default Digimagi;
